<h3>
  <span [ngClass]="color" class="badge rounded-pill">{{ state || 'N/A' }}</span>
</h3>
